<template>
  <div v-if="show" class="d-flex">
    <div class="w-100">
      <div :class="'alert ' + color" role="alert">
        <div class="text-right"></div>
        <div class="d-flex flex-column gap-1">
          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
              <i :class="icon + ' fa-2x'" style="margin-right: 10px"></i>
              <h3>{{ title }}</h3>
            </div>
            <button :class="color" @click="close">
              <i class="fas fa-times fa-2x"></i>
            </button>
          </div>
          <div>
            <div v-html="message"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MessageAlert",
  data() {
    return {
      show: true,
      color: "",
    };
  },
  props: {
    icon: {
      type: String,
      default: "fas fa-exclamation-triangle",
    },
    title: {
      type: String,
      default: "Titulo",
    },
    message: {
      type: String,
      default: "<div>Texto do <b>Alert!</b></div>",
    },
    is_active: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    close() {
      this.show = false;
    },
  },
  mounted() {
    if (this.is_active === 0) {
      this.show = false;
      return;
    }
    switch (this.icon) {
      case "fa fa-check":
        this.color = "alert-success";
        break;
      case "fa fa-exclamation-triangle":
        this.color = "alert-danger";
        break;
    }
  },
};
</script>

<style scoped>
h3 {
  margin: 0;
  padding: 0;
}

button {
  background: none;
  border: 0;
  padding-right: 10px;
  padding-left: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 50%;
  cursor: pointer;
}

button:hover {
  background: rgb(255, 255, 255, 0.2);
}

button:focus {
  outline: none;
}

button:hover > i {
  color: white;
}
</style>
